export default {
    LOADING: "loading",
    PLAYING: "playing",
    PAUSED: "paused"
}